
import { IChartContainer } from "../models/base/chart-container.interface";
import { ChartStyleSettingsModel } from "../models/chart-style/chart-style-settings.model";
import { IComponent } from "./component.interface";
import { EMACloudUIManager } from '../models/ema-cloud/ema-cloud-ui.manager';
declare const $: any;

export class EMACloudSettingsPopupComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private base: IChartContainer;
    private jqueryReady = false;
    private indicatorsReady = false;
    private chartStyle: ChartStyleSettingsModel | null = null;
    private uiManager: EMACloudUIManager | null = null;

    constructor(base: IChartContainer) {
        this.base = base;
        this.create();
        this.subscribeChartService();
        this.checkIfJQueryExist(0);
    }

    public show() {
        const sections = $(this.element).find('.section');
        if (sections?.length) {
            for (let i = 0; i < sections.length; i++) {
                if (i == 0) {
                    $(sections[i]).addClass('active');
                } else {
                    $(sections[i]).removeClass('active');
                }
            }
        }

        this.element.classList.add('active');
    }

    public close() {
        this.element.classList.remove('active');
    }

    public isActive() {
        return this.element.classList.contains('active');
    }

    private subscribeChartService() {
        this.base.chartService.subscribeChartStyleData((chartStyle: ChartStyleSettingsModel) => {
            this.chartStyle = chartStyle;
        });
        this.base.chartService.subscribeInitChartIndicatorsData(() => {
            setTimeout(() => {
                this.indicatorsReady = true;
            }, 500);
        });
    }

    private onClick() {
        this.element.querySelectorAll<HTMLElement>('.submit').forEach((el: HTMLElement) => {
            el.addEventListener('click', () => {
                this.uiManager?.requestSaveSettings();
                this.close();
            });
        });
        this.element.querySelectorAll<HTMLElement>('.close').forEach((el: HTMLElement) => {
            el.addEventListener('click', () => {
                if (el.classList.contains('revert')) {
                    this.uiManager?.revertSettings();
                } else {
                    this.close();
                }
            });
        });
    }

    private checkIfJQueryExist(retriesCount: number) {
        if (retriesCount >= 100) {
            return;
        }

        if (typeof $ === 'undefined' || typeof $.spectrum === 'undefined') {
            setTimeout(() => {
                this.checkIfJQueryExist(retriesCount++);
            }, 500);
        } else {
            this.jqueryReady = true;
        }
    }

    public render(save: boolean) {
        if (!this.chartStyle || !this.jqueryReady || !this.indicatorsReady) {
            return;
        }

        if (!this.uiManager) {
            this.uiManager = new EMACloudUIManager(this.base, this.element.querySelector<HTMLElement>('.content'), false);
        }

        this.uiManager?.init(save);
    }

    private create() {
        if (this.element) {
            this.element.remove();
        }

        const div = document.createElement('div');
        div.className = `ema-settings settings-popup`;
        div.innerHTML = `
        <div class="wrapper">
            <div class="head">   
                <p class="title">TradeWave Settings</p>
                <button class="close" type="button">
                    <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width="17" height="17" fill="currentColor">
                            <path d="m.58 1.42.82-.82 15 15-.82.82z"></path>
                            <path d="m.58 15.58 15-15 .82.82-15 15z"></path>
                        </svg>
                    </span>
                </button>
            </div>
            <div class="content" style="max-height: ${this.base.chartWrapper?.clientHeight - 150}px;"></div>
            <div class="footer">
                <button class="close revert" style="position: absolute; left: 0;">Revert</button>
                <button class="close">Close</button>
                <button class="submit">Ok</button>
            </div>
        </div>
        `;

        this.element = div;
        this.base.chartWrapper?.insertAdjacentElement('beforeend', this.element);
        setTimeout(() => {
            this.onClick();
        }, 300);
    }
}